// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"a2f447d6","310":"09567dde","425":"f1b7dd26","520":"09d70eed","748":"c31fceab","789":"5880c970","851":"07a6052c"}[chunkId] + ".css";
};